import {formatMoney} from '@shopify/theme-currency';

const $body = $('body');

const initAjaxCart = () => {
  $body.on("change", ".mini-cart-item-quantity input", function() {
    updateItem($(this).data('line-id'), $(this).val());
  });

  $(document).on('click', '.ajax-add-to-cart', function(e) {
    e.preventDefault();

    const $cartForm = $(this).closest('form');
    addItem($cartForm);

    return false;
  });

  $(document).on('click', '.mini-cart-items .cart-remove', function (e) {
    e.preventDefault();

    removeItem($(this).data('line-id'));

    return false;
  });
};

export default initAjaxCart;

function openMiniCart() {
  $('#miniCartOffCanvas').foundation('open');
}

export function addItem($form) {
  const $cartButton = $form.find('[data-submit-button]');
  const $cartButtonLabel = $cartButton.find('[data-submit-button-text]');

  $.ajax({
    url: '/cart/add.js',
    dataType: 'json',
    cache: false,
    type: 'post',
    data: $form.serialize(),
    beforeSend: function() {
      $cartButton.attr('disabled', 'disabled').addClass('disabled');
    },
    success: function(itemData) {
      $cartButtonLabel.text('Added to Cart');

      window.setTimeout(function(){
        $cartButton.removeAttr('disabled').removeClass('disabled');
        $cartButtonLabel.text('Add to Cart');
      }, 1000);

      $.ajax({
        url: '/cart.js',
        dataType: "json",
        cache: false,
        success: function(cart) {
          refreshCart(cart);
          openMiniCart();
        }
      });
    },
    error: function(XMLHttpRequest) {
      $cartButton.removeAttr('disabled').removeClass('disabled');
    }
  });
}

function removeItem(lineId) {
  $.ajax({
    url: '/cart/change.js',
    dataType: 'json',
    cache: false,
    type: 'post',
    data: { quantity: 0, line: lineId },
    success: function (data) {
      refreshCart(data);
    }
  });
}

function updateItem(lineId, quantity) {
  $.ajax({
    url: '/cart/change.js',
    dataType: 'json',
    cache: false,
    type: 'post',
    data: {
      quantity: quantity,
      line: lineId
    },
    success: function (data) {
      refreshCart(data);

      const lineIdIndex = lineId - 1;
      const updatedQuantity = (typeof data.items[lineIdIndex] === "undefined") ? 0 : data.items[lineIdIndex].quantity;

      if (quantity < 1 || quantity == updatedQuantity) {
        return;
      }

      const $quantityWarning = '<p class="quantity-warning">There was a problem when trying to update the number of items in your cart.</p>';
      const $lineItemField = $(`.mini-cart-item-quantity [data-line-id=${lineId}]`);

      $('.quantity-warning').remove();
      $lineItemField.parent().after($quantityWarning);
      $lineItemField.val(updatedQuantity);
    }
  });
}

function refreshCart(cart) {
  const $cartCount = $('.cart-count');
  const $miniCartForm = $('.mini-cart-content-form');
  const $miniCartEmptyMessage = $('.mini-cart-empty-message');
  let cartItemsHtml = '';

  $cartCount.text(cart.item_count);

  if (cart.item_count === 0) {
    $miniCartEmptyMessage.removeClass('hidden');
    $miniCartForm.addClass('hidden');
  } else {
    $miniCartEmptyMessage.addClass('hidden');
    $miniCartForm.removeClass('hidden');

    $.each(cart.items, function(index, item) {
      const lineId = index + 1;
      const imageSrc = item.image.replace(/(\.[^.]*)$/, "_compact$1").replace('http:', '');

      let formattedTitle = item.title;

      if (item.properties) {
        $.each(item.properties, function(title, value) {
          if (value) {
            formattedTitle += `<div class="line-item">${title}: ${value}</div>`;
          }
        });
      }

      cartItemsHtml +=
        `<li class="mini-cart-item">
          <div class="mini-cart-item-image">
            <a href="${item.url}">
              <img src="${imageSrc}" alt="${item.title}" />
            </a>
          </div>
          
          <div class="mini-cart-item-content">
            <div class="mini-cart-item-title">
              <a href="${item.url}">
                ${formattedTitle}
              </a>
            </div>
            
            <span class="mini-cart-item-price money">${formatMoney(item.price, $('body').data('money-format'))}</span>
            
            <div class="mini-cart-item-quantity cart-quantity">
              <label for="updates_${item.key}" class="show-for-sr">Quantity</label>
              <input
                type="number"
                name="updates[]"
                id="updates_${item.key}"
                value="${item.quantity}"
                data-line-id="${lineId}"
                min="0" />
            </div>
          </div>
          
          <div class="mini-cart-item-remove"><a href="/cart/change?line=${lineId}&amp;quantity=0" class="cart-remove" data-line-id="${lineId}"><small>Remove item</small></a></div>
        </li>`;
    });
  }

  $('.mini-cart-items').html(cartItemsHtml);
  $('.mini-cart-subtotal .money').html(formatMoney(cart.total_price, $body.data('money-format')));
}
